import {
  Button as MuiButton,
  Dialog as MuiDialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogTitle as MuiDialogTitle,
  Typography as MuiTypography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const UploadOncoreDialog = ({
  isOpen,
  onClose,
  environment,
  message,
  handleUploadToOnCore,
}) => {
  const { t } = useTranslation();

  return (
    <MuiDialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="upload-oncore-dialog-title"
      aria-describedby="upload-oncore-dialog-description"
    >
      <MuiDialogTitle
        id="upload-oncore-dialog-title"
        sx={{
          padding: "16px 24px",
        }}
      >
        <MuiTypography
          sx={{ fontSize: 20, fontWeight: 600, textTransform: "capitalize" }}
        >
          {environment}
        </MuiTypography>
      </MuiDialogTitle>

      <MuiDialogContent
        sx={{
          padding: "24px",
        }}
      >
        {message}
      </MuiDialogContent>

      <MuiDialogActions>
        <MuiButton color="primary" onClick={onClose} sx={{ fontSize: "17px" }}>
          {t("buttons.caps.cancel")}
        </MuiButton>
        <MuiButton
          color="primary"
          onClick={handleUploadToOnCore}
          sx={{ fontSize: "17px" }}
        >
          {t("buttons.caps.ok")}
        </MuiButton>
      </MuiDialogActions>
    </MuiDialog>
  );
};

export default UploadOncoreDialog;
